import { client } from "./fetch";
import {
	LeadTierRequest,
	LeadTierResponse,
} from "./types";

export const createLeadTier = async (
	data: LeadTierRequest
): Promise<LeadTierResponse | void> => {
	const response = await client.post<LeadTierRequest, LeadTierResponse>(
		{
			url: `/bikri/shopdeck/tier`,
			payload: {
				...data,
			},
		}
	);
	return response.data;
};
